import api from './api';

export const getPresets = () => api.get('simulados/presets');

export const createProposal = ({ preset, taxonomyIds = [], seed = null }) => api.post('simulados/proposals', { preset, taxonomy_ids: taxonomyIds, ...(seed != null ? { seed } : {}) });

export const swapProposal = ({ preset, taxonomyIds = [], descriptorCode, selectedQuestionIds }) =>
  api.post('simulados/proposals/swap', { preset, taxonomy_ids: taxonomyIds, descriptor_code: descriptorCode, selected_question_ids: selectedQuestionIds });

export const applyProposal = (questionBookId, items) => api.post(`question_books/${questionBookId}/apply_proposal`, { items });
